import LoadingIndicator from "components/Atoms/LoadingIndicator/LoadingIndicator";

export default LoadingIndicator;
